import React, { useState, useEffect, useRef } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import Layout from '../Layouts/pageLayout';
import api from '../components/setAxios';
import Blog from "../components/blog";
import Breadcrumbs from "../components/breadcrumbs";
import Navbar from "../components/navbarCategory";
import ScrollToTop from '../components/scrollToTop';
import { unformatUrl,formaturl} from '../config/staticData';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../components/loading';
import {HELMETSEO,BREADSEO} from '../components/seopage';
import NOTFOUND from '../pages/notfound';

function Search() {
    let { type, id, name } = useParams();
    const navigate = useNavigate();
    const [input, setInput] = useState('');
    const [blogs, setBlogs] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [loading, setLoading] = useState(true);
    const inputRef = useRef(null); // Reference for the input element

    const handleChange = (event) => {
        setInput(event.target.value);
        setPageNumber(1); // Reset to first page on new search
    };

    async function fetchBlogs(value, page = 1) {
        try {
            const response = await api.get(`/blog/GetBlogsBySearch/${encodeURIComponent(value)}?page=${page}&size=12`);
            if (page === 1) {
                setBlogs(response.data.items);
            } else {
                setBlogs(prevBlogs => [...prevBlogs, ...response.data.items]);
            }
            setTotalPage(response.data.totalCount);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    }

    async function fetchBlogsByHashtag() {
        try {
            const response = await api.get(`/blog/GetBlogsByType/hashtag/${id}`);
            setBlogs(response.data);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    }

    async function fetchBlogsByCategory() {
        try {
            const response = await api.get(`/blog/GetBlogsByType/blogCategory/${id}`);
            setBlogs(response.data);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    }

    const fetchData = () => {
        setPageNumber(prevPageNumber => prevPageNumber + 1);
    }

    useEffect(() => {
        const loadData = async () => {
            setLoading(true); 
            setBlogs([]);
            setPageNumber(1); 
            try {
                switch (type) {
                    case 'hashtag':
                        await fetchBlogsByHashtag();
                        break;
                    case 'search':
                    case 'new':
                        await fetchBlogs(input, 1);
                        break;
                    case 'blogCategory':
                        await fetchBlogsByCategory();
                        break;
                    default:
                        await fetchBlogs(input, 1);
                        break;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false); 
            }
        };

        loadData();
    }, [type, id, input]);

    useEffect(() => {
        if (pageNumber > 1) {
            fetchBlogs(input, pageNumber);
        }
    }, [pageNumber]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus(); // Focus on the input element when the component mounts
        }
    }, []);

    useEffect(() => {
        if (!loading && inputRef.current) {
            inputRef.current.focus(); // Keep the focus on the input element after loading
        }
    }, [loading]);


    if (loading) {
        return <Loading />; 
    }

    return (
        <>
            <Layout header={Navbar}>
                <HELMETSEO
                    title={"مقالات"}
                    description={unformatUrl(name)}
                    keyword={unformatUrl(name)}
                />

                {name && (
                    <BREADSEO title={name} pageUrl={`${process.env.REACT_APP_BASE_PATH}/${formaturl(name)}`} />
                )}

                <section className="search-content">
                    <div className="main-aside" >
                        <ScrollToTop />
                    </div>
                    <div className="main-content" >
                        <div className="archive-header" >
                            <Breadcrumbs />
                            <div className="archive-header-sep"></div>
                            {type === 'hashtag' && (
                                <div className="media-header">
                                    <i className="fa-solid fa-hashtag"></i>
                                    <div className="media-header-content">
                                        <h4>{unformatUrl(name)}</h4>
                                    </div>
                                </div>
                            )}
                            {!type && type !== 'new' && (
                                <div className="media-header">
                                    <i className="fa fa-search" aria-hidden="true"></i>
                                    <div className="media-header-content">
                                        <input
                                            type="text"
                                            placeholder="جستجو کنید . . ."
                                            value={input}
                                            onChange={handleChange}
                                            ref={inputRef} // Set the ref to the input element
                                        />
                                    </div>
                                </div>
                            )}
                            {type === 'blogCategory'  && (
                                <div className="media-header">
                                    <i className="fa-regular fa-folder"></i>
                                    <div className="media-header-content">
                                        <h4>{unformatUrl(name)}</h4>
                                    </div>
                                </div>
                            )}
                            <div className="archive-header-sep"></div>
                        </div>
                        <div className='search-body'>
                            {blogs.map((item, index) => (
                                <Blog key={index} data={item} />
                            ))}
                            <InfiniteScroll
                                dataLength={blogs.length}
                                next={fetchData}
                                hasMore={blogs.length < totalPage}
                                loader={<Loading />}
                            />
                        </div>
                    </div>
                </section>
            </Layout>
        </>
    )
}

export default Search;
